import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

interface DateInputProps extends Omit<TextFieldProps, "onChange"> {
  value: string;
  onChange: (value: string) => void;
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  onChange,
  ...textFieldProps
}) => {
  const applyDateMask = (inputValue: string): string => {
    // Remove tudo que não é número
    const numbers = inputValue.replace(/\D/g, "");

    // Aplica a máscara DD/MM/AAAA
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 4) {
      return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    } else {
      return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(
        4,
        8
      )}`;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const maskedValue = applyDateMask(inputValue);
    onChange(maskedValue);
  };

  return (
    <TextField
      {...textFieldProps}
      // type="number"
      value={value}
      onChange={handleChange}
      placeholder="DD/MM/AAAA"
      inputProps={{
        maxLength: 10,
        inputMode: "numeric",
        ...textFieldProps.inputProps,
      }}
    />
  );
};

export default DateInput;
